import { object, string, number, bool } from 'yup';

import useCredentials from 'api/hook/useCredentials';

import { baseAxios, handleError } from 'api';
import { useMutation, useQuery } from '@tanstack/react-query';

// eslint-disable-next-line no-unused-vars
const OrderScheme = object({
  invoiceId: string().required(),
  total: number().required(),
  amount: number().required(),
  userId: string().required(),
  qrURL: string().required(),
  status: string().required().oneOf(['create', 'process', 'success']),
  isPaid: bool(),
});

/**
 * @return {import('@tanstack/react-query').UseQueryResult<any, any>}
 */
export function useOrders() {
  const authAxios = useCredentials();

  return useQuery({
    queryKey: ['orders'],
    queryFn: () => baseAxios(authAxios, { url: 'order' }),
    onError: handleError,
    initialData: [],
  });
}
